const NOOP_ACTIONS_MOD = {
  server: {}
};
export {
  NOOP_ACTIONS_MOD
};
